import * as React from "react";

const SvgComponent = ({ color = "#999999" }) => (
  <svg width={16} height={15} fill="none">
    <path
      d="M11.22 9.434h-.677l-.24-.232a5.55 5.55 0 0 0 1.346-3.627 5.574 5.574 0 1 0-5.574 5.574 5.55 5.55 0 0 0 3.627-1.346l.232.24v.677L14.222 15l1.278-1.278-4.28-4.288Zm-5.145 0a3.854 3.854 0 0 1-3.86-3.86 3.854 3.854 0 0 1 3.86-3.859 3.854 3.854 0 0 1 3.859 3.86 3.854 3.854 0 0 1-3.86 3.859Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;